import { intl } from '@fullstory/intl';

export const BOX_WIDTH = 280;
export const BOX_HEIGHT = 109;
export const BOX_TOP_BAR_HEIGHT = 8;
export const TOTAL_BOX_HEIGHT = BOX_HEIGHT + BOX_TOP_BAR_HEIGHT;
export const BOX_LEFT_RIGHT_MARGIN = 12;

export const LINK_LENGTH = 250;
export const JOINT_WIDTH = 15; // width of the end point indicators for links
export const CHART_LEFT_RIGHT_PADDING = 20;
export const CHART_HEIGHT = 950;
export const MIN_INTERACTIONS = 5;
export const LINK_LENGTH_MINUS_MARGIN = LINK_LENGTH - BOX_LEFT_RIGHT_MARGIN;

export const CONTAINER_HEIGHT = 896;

export const hideAction = {
  id: 'hide',
  label: intl.formatMessage({ defaultMessage: 'Hide event', id: 'GmdXlh' }),
  testId: 'hide-event-option',
} as const;
export const groupAction = {
  id: 'group',
  label: intl.formatMessage({ defaultMessage: 'Group by property', id: 'bu9AJf' }),
  testId: 'group-custom-event-option',
} as const;
export const groupPageAction = {
  id: 'groupPage',
  label: intl.formatMessage({ defaultMessage: 'Group by property', id: 'bu9AJf' }),
  testId: 'group-page-var-option',
} as const;
export const groupElementAction = {
  id: 'groupElement',
  label: intl.formatMessage({ defaultMessage: 'Group by property', id: 'bu9AJf' }),
  testId: 'group-elem-var-option',
} as const;

export const OtherNodeIdentifier = 'Other';
